module.exports = __webpack_public_path__ + "img/lebanon.ed7ed52d.svg";